module.exports = __webpack_public_path__ + "static/media/profile_22.660b2064.jpg";